module.exports = "https://static.wagwalking.com/_next/static/images/dog-walking-city-video-section-desktop-a34b9ebe26bef16edeb06fec4776dbd5.jpg";